import omit from 'lodash/omit';
import type { StoreActionApi } from 'react-sweet-state';

import type { ChangeId, IssueAdjustmentsState } from '../../../types';

export const clearBufferForChangeId =
	({ changeId }: { changeId: ChangeId }) =>
	({ setState, getState }: StoreActionApi<IssueAdjustmentsState>) => {
		const { buffer, bufferTimeouts } = getState();

		setState({
			buffer: omit(buffer, changeId),
			bufferTimeouts: omit(bufferTimeouts, changeId),
		});
	};

export const clearAllBufferTimeouts =
	() =>
	({ getState }: StoreActionApi<IssueAdjustmentsState>) => {
		const { bufferTimeouts } = getState();

		Object.values(bufferTimeouts).forEach((timeoutId) => {
			clearTimeout(timeoutId);
		});
	};
